import { WALLET_UPDATE_WALLET_STORAGE_REQUEST } from 'wallet-manager';
import { eventBus } from '@atc/cai-event-bus';

// TODO: Add unit tests
const addHideReceiptListing = _ref => {
  let {
    types
  } = _ref;
  return payload => async (dispatch, getState) => {
    const paymentsInfo = getState()?.payments;
    eventBus.emit(WALLET_UPDATE_WALLET_STORAGE_REQUEST, {
      currentPaymentsInfo: {
        ...paymentsInfo
      },
      payload,
      actionCode: 'addHideReceiptListing'
    });
    dispatch({
      type: types.ADD_HIDE_RECEIPT_LISTING,
      payload: {
        ...payload
      }
    });
  };
};
export default addHideReceiptListing;